import React from 'react';
import { Check } from 'lucide-react';
import { useScrollReveal } from '../hooks/useScrollReveal';
export function Solucion() {
  const revealRef = useScrollReveal();
  const imgRef = useScrollReveal();
  const textRef = useScrollReveal();
  return <section id="solucion" className="py-14 sm:py-[90px] px-6" style={{
    background: 'linear-gradient(160deg, #0f0c00 0%, #1a1208 60%, #0a0a0a 100%)'
  }} data-id="element-344">
      <div ref={revealRef} className="max-w-[1060px] mx-auto reveal" data-id="element-345">
        <div className="text-center" data-id="element-346">
          <span className="text-[11px] tracking-[5px] uppercase text-oro mb-4 block" data-id="element-347">
            La solución diferenciadora
          </span>
          <h2 className="font-playfair text-[clamp(28px,4.5vw,52px)] font-bold leading-[1.15] mb-6" data-id="element-348">
            Presentamos{' '}
            <em className="italic text-oro-claro" data-id="element-349">El Método Italiano™</em>
          </h2>
          <div className="w-[60px] h-[2px] bg-gradient-to-r from-oro to-transparent mx-auto my-5" data-id="element-350"></div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-[60px] items-center mt-12" data-id="element-351">
          <div ref={imgRef} className="reveal-left" data-id="element-352">
            <img src="https://i.postimg.cc/0QDt0x1R/9d2524e5-min.png" alt="El Método Italiano" className="rounded-md w-full h-auto object-contain shadow-[0_30px_80px_rgba(0,0,0,0.6)]" data-id="element-353" />
          </div>
          <div ref={textRef} className="reveal-right" data-id="element-354">
            <div className="inline-flex items-center gap-1.5 bg-gradient-to-r from-oro to-oro-claro text-negro font-montserrat font-black text-[13px] tracking-[1.5px] px-[18px] py-[7px] rounded-sm mb-5 uppercase" data-id="element-355">
              <span className="text-[11px] font-bold" data-id="element-356">TM</span> El Método
              Italiano™
            </div>
            <h2 className="font-playfair text-[clamp(22px,3vw,36px)] font-bold leading-[1.15] mb-5" data-id="element-357">
              El mismo sistema que usan los nonnos en Nápoles. Adaptado al
              celiaco moderno.
            </h2>
            <p className="text-[15px] text-white/70 leading-[1.8] mb-5" data-id="element-358">
              Durante décadas, los artesanos italianos han controlado la pasta
              con tres variables precisas: la mezcla de harinas, la hidratación
              exacta y el tiempo de reposo. Nosotros tomamos esa sabiduría y la
              reconstruimos sin gluten, sin comprometer ni un gramo de sabor ni
              textura.
            </p>
            <p className="text-[15px] text-white/70 leading-[1.8] mb-5" data-id="element-359">
              No es magia. Es química aplicada a la cocina real. Cada receta del
              ebook sigue las 3 etapas del Método Italiano™ para garantizar que
              tu pasta quede{' '}
              <strong className="text-white" data-id="element-360">
                firme, elástica y deliciosa
              </strong>
              , sin importar si usas harina de arroz, almidón de tapioca o trigo
              sarraceno.
            </p>
            <p className="text-[15px] text-white/70 leading-[1.8] mb-5" data-id="element-361">
              El resultado: pasta que no avergüenza. Pasta que sirves con
              orgullo. Pasta que nadie identifica como "sin gluten" hasta que tú
              lo dices.
            </p>
            <div className="inline-flex items-center gap-2 bg-oro/10 border border-oro/40 rounded-sm px-3.5 py-1.5 text-[12px] text-oro-claro font-semibold tracking-[1px] mt-5" data-id="element-362">
              <Check size={11} data-id="element-363" /> Etapa 1: Mezcla · Etapa 2: Hidratación · Etapa
              3: Reposo
            </div>
          </div>
        </div>
      </div>
    </section>;
}